import { defineComponent as s, getCurrentInstance as p, h as t } from "vue";
import { defineStore as l } from "@sunrise/pinia";
const c = l("hydration", {
  state: () => ({})
});
let u = 0;
const h = s({
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  setup({ name: e }) {
    var r, n, a;
    const d = p(), o = (a = (r = d == null ? void 0 : d.proxy) == null ? void 0 : (n = r.$slots).default) == null ? void 0 : a.call(n), i = e + ++u + "hydration";
    return c().$patch({
      // @ts-ignore
      [i]: o[0].props
    }), o ? () => t(
      "div",
      {
        "data-hydration": e,
        "data-cms-id": i
      },
      [t(o[0])]
    ) : (console.error("No component to hydrate"), () => t("div", ["No component to hydrate"]));
  }
});
export {
  h as MsHydration,
  c as useHydrationStore
};
